export { default } from "./AppPaper";
export type { AppPaperProps } from "./AppPaper";
